import * as styles from "./KnobLabel.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { useKnobContext } from "./Knob.context";
import type { KnobLabelProps } from "./Knob.types";

export function KnobLabel({
  className,
  children,
}: KnobLabelProps): JSX.Element {
  const { labelId } = useKnobContext();

  return (
    <span
      id={labelId}
      data-slot="knob-label"
      className={clsx(styles.label, className)}
    >
      {children}
    </span>
  );
}
